import type { TPracticeQr, TPracticeQrCreatePayload, IPracticeQrFilter } from "./types";
import { createPathParamCRUD, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";

export * from "./types";

const SLUG = "qr/practice-qr";

export default createService(SLUG, {
  ...createPathParamCRUD<TPracticeQr, NoPathParams, IPracticeQrFilter, TPracticeQrCreatePayload>(
    SLUG
  ),
});
